import { useQuery } from '@tanstack/react-query'

import { getOrganization } from '@src/api'
import { DefaultApiGetOrganizationRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchOrganization = (
  params: DefaultApiGetOrganizationRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getOrganization(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_ORGANIZATION, params.organizationId],
  })
}
